import { Component, OnInit, Input } from '@angular/core';
import { LienParental } from 'app/models/lien-parental';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationsService } from 'app/utils/notifications.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LienParentalService } from 'app/core/lien-parental.service';

@Component({
  selector: 'app-ajout-lien',
  templateUrl: './ajout-lien.component.html',
  styleUrls: ['./ajout-lien.component.css']
})
export class AjoutLienComponent implements OnInit {
  @Input()
  lien:LienParental;
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
    private notification: NotificationsService,
    private lienService: LienParentalService,
  ) { }


  ngOnInit() {
    this.initForm();
  }

  submitForm() {
    const valeur: any = this.form.value;

    console.log(valeur);
    this.lienService.create(valeur).subscribe(
      lien => {
        if (this.lien) {
          this.notification.addToast(
            "lien parental Modifié",
            "infos",
            "success"
          );
        } else {
          this.notification.addToast(
            "lien bien créé",
            "infos",
            "success"
          );
        }
      },
      error => {
        if (this.lien) {
          this.notification.addToast(
            "Erreur sur Modification",
            'Attention', 'error'
          );
        } else {
          this.notification.addToast(
            "Erreur sur Création",
            'Attention', 'error'
          );
        }
      }
    );

    this.activeModal.dismiss("cancelled by user");
    this.ngOnInit();
  }


  public initForm() {
    if (this.lien) {
      this.form = this.formBuilder.group({
        libelle: [this.lien.libelle, Validators.required],
        id: [this.lien.id]
      });
    } else {
      this.form = this.formBuilder.group({
        libelle: [null, Validators.required],
        id: [null]
      });
    }
  }
  dismiss() {
    this.activeModal.dismiss("cancelled by user");
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/parametrage/lien-parental/ajout-lien/ajout-lien.component.ts